<div [class]="computedClass()">
  <ng-content></ng-content>
</div>
